export default "{\n    \"MORNING\": \"Mañana\",\n    \"AFTERNOON\": \"Tarde\",\n    \"EVENING\": \"Noche\"\n}"